import { createSlice } from "@reduxjs/toolkit";
import * as ContactUsApi from "../api/contact-us";

const contactUs = createSlice({
  name: "contactUs",
  initialState: {
    loading: false,
    error: null,
    list: [],
    summary: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getListSuccess: (state, action) => {
      state.list = action.payload.docs;
      state.summary = action.payload.summary;
      state.loading = false;
    },
    deleteSuccess: (state, action) => {
      const id = action.payload;
      state.list = state.list.filter((item) => item?._id !== id);
      if (state.summary?.count != null) {
        state.summary = { ...state.summary, count: state.summary.count - 1 };
      }
    },
  },
});

export const getListContactUs = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await ContactUsApi.getListContactUs(params);
    dispatch(getListSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = contactUs;
export const { setLoading, setError, getListSuccess, deleteSuccess } = actions;
export default reducer;
